import { render } from "./ResumenMensualBarChart.vue?vue&type=template&id=2ae28b80&scoped=true"
import script from "./ResumenMensualBarChart.vue?vue&type=script&lang=js"
export * from "./ResumenMensualBarChart.vue?vue&type=script&lang=js"

import "./ResumenMensualBarChart.vue?vue&type=style&index=0&id=2ae28b80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae28b80"]])

export default __exports__